import { render, staticRenderFns } from "./add-edit-incidente-otros.vue?vue&type=template&id=59d29e40&"
import script from "./add-edit-incidente-otros.vue?vue&type=script&lang=js&"
export * from "./add-edit-incidente-otros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports